<template>
  <!-- <svg
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    x="0px"
    y="0px"
    viewBox="0 0 122 146"
    style="enable-background: new 0 0 122 146"
    xml:space="preserve"
  > -->
  <svg
    x="0px"
    y="0px"
    viewBox="0 0 122 95"
    style="enable-background: new 0 0 122 95"
    xml:space="preserve"
  >
    <g id="レイヤー_4"></g>
    <g id="txt"></g>
    <!-- <g id="bg" class="st0"></g> -->
    <g>
      <g>
        <!-- <g>
          <g class="st3">
            <path
              class="st4"
              d="M23.719,118.951c-0.919,0-1.799,0.04-2.879,0.2v-4.279c1.08,0.16,1.88,0.24,2.959,0.24h1.64v-3.279
                    c0-2-0.039-2.88-0.239-4.08h4.639c-0.16,1.16-0.199,2.04-0.199,4.04v3.319h1.359c0.88,0,1.479-0.04,2.119-0.16v4.119
                    c-0.8-0.08-1.319-0.12-2.119-0.12h-1.359v6.039c0.919-0.28,1.6-0.52,3.359-1.2v3.92c-0.721,0.24-1.84,0.68-3.359,1.239v11.519
                    c0,1.92-0.521,2.88-1.84,3.439c-0.84,0.359-1.68,0.479-3.92,0.479c-0.64,0-1.04,0-1.999-0.04c-0.16-1.76-0.36-2.6-0.92-4.159
                    c1.359,0.16,2.319,0.24,3.119,0.24c1.12,0,1.359-0.2,1.359-1.16v-8.958c-1.919,0.6-2.759,0.92-4.039,1.439l-0.88-4.399
                    c1.12-0.08,2.52-0.399,4.919-1.079v-7.319H23.719z M48.675,120.151c-0.319,0.92-0.399,1.359-0.64,2.479
                    c-1.319,5.879-2.88,11.638-4.239,15.518c3.279-0.44,4.959-0.72,7.999-1.4c-1.12-3.279-1.88-5.119-3.479-8.479l3.839-1.279
                    c2.56,5.319,3.96,9.118,5.719,15.558l-3.959,1.6c-0.479-1.8-0.6-2.24-0.96-3.64c-4.439,1.04-4.799,1.12-13.317,2.399
                    c-1.28,0.2-1.32,0.2-1.84,0.32c-0.32,0.08-0.32,0.08-0.56,0.16l-0.84-4.56c-0.76,2.279-1.48,3.879-2.6,5.679
                    c-1.36-1.439-2.08-2.039-3.52-3.039c1.399-2.24,2.199-4.039,2.879-6.719c0.84-3.28,1.32-8.879,1.32-15.798
                    c0-2.8-0.08-4.319-0.2-5.639c1.16,0.16,2.2,0.2,3.999,0.2h4.96v-2.4c0-1.359-0.04-2.079-0.24-3.079h4.799
                    c-0.16,0.88-0.2,1.64-0.2,3.039v2.44h5.6c1.84,0,2.92-0.08,4.119-0.24v4.319c-1.319-0.12-2.68-0.2-4.119-0.2H38.677
                    c-0.04,10.398-0.68,16.357-2.239,21.316c0.399,0.04,0.56,0.04,0.76,0.04c0.439,0,1.399-0.08,2.319-0.16
                    c1.08-3.159,2.319-7.679,3.119-11.397c0.72-3.4,1.2-6.439,1.24-8.079L48.675,120.151z"
            />
            <path
              class="st4"
              d="M83.277,121.591c1,3.6,3.119,7.479,5.759,10.479c2.96,3.359,6.279,5.639,11.038,7.599
                    c-1.359,1.6-1.92,2.439-2.919,4.599c-4.279-2.199-7.039-4.239-9.879-7.318c-2.6-2.76-4.559-5.959-6.039-9.679
                    c-1.199,4.12-3.319,7.56-6.519,10.719c-2.72,2.68-5.6,4.56-9.559,6.278c-0.68-1.52-1.52-2.759-2.8-4.199
                    c2.88-1.159,4.479-1.999,6.479-3.399c5.359-3.799,8.038-8.278,8.998-15.077h-9.438c-2.52,0-3.679,0.08-4.999,0.28v-5.079
                    c1.24,0.199,2.68,0.279,5.039,0.279h9.799c0.08-1.999,0.12-2.64,0.12-4.719c0-1.68-0.12-2.88-0.28-3.999h5.279
                    c-0.2,1.399-0.24,1.999-0.28,4.679c0,1.64-0.04,2.56-0.08,4.039h10.599c2.279,0,3.679-0.08,5.039-0.279v5.079
                    c-1.6-0.2-2.8-0.28-4.999-0.28H83.277z"
            />
          </g>
        </g> -->
        <circle class="st4" cx="61" cy="46.036" r="44.543" />
        <g>
          <path
            class="st5"
            d="M61,69.671c-1.657,0-3-1.343-3-3v-41.27c0-1.657,1.343-3,3-3s3,1.343,3,3v41.27
                C64,68.328,62.658,69.671,61,69.671z"
          />
          <path
            class="st5"
            d="M81.635,49.036H40.365c-1.657,0-3-1.343-3-3s1.343-3,3-3h41.271c1.657,0,3,1.343,3,3
                S83.292,49.036,81.635,49.036z"
          />
        </g>
      </g>
    </g>
  </svg>
</template>
<script>
export default {};
</script>
<style lang="scss">
.st0 {
  display: none;
}
// .st1 {
//   display: inline;
//   fill: #d2ddf0;
// }
// .st2 {
//   display: inline;
//   fill: #1e58b5;
// }
.st3 {
  enable-background: new;
}
.st4 {
  fill: #ffffff;
}
.st5 {
  fill: #1e58b5;
}
// .st6 {
//   fill: none;
//   stroke: #1e58b5;
//   stroke-width: 6;
//   stroke-linecap: round;
//   stroke-linejoin: round;
//   stroke-miterlimit: 10;
// }
// .st7 {
//   fill: #ffffff;
//   stroke: #1e58b5;
//   stroke-width: 6;
//   stroke-linecap: round;
//   stroke-linejoin: round;
//   stroke-miterlimit: 10;
// }
// .st8 {
//   fill: #1e58b5;
//   stroke: #1e58b5;
//   stroke-width: 4;
//   stroke-linecap: round;
//   stroke-linejoin: round;
//   stroke-miterlimit: 10;
// }
// .st9 {
//   fill: none;
//   stroke: #1e58b5;
//   stroke-width: 6;
//   stroke-linejoin: round;
//   stroke-miterlimit: 10;
// }
</style>